import { UserUtils, userUtils } from "@/stores/UserStore";
import { useOperationModal } from "./useOperationModal";
import { userCurrentPanelState } from "@/stores/ComponentsState/UserCurrentPanelState";

export const useOperationModalForCurrentUsers = () => {
  return useOperationModal<UserUtils>(userUtils, userCurrentPanelState.modalData);
};
